// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st0{fill-rule:evenodd;fill:url(#SVGID_0_)}.st0,.st1{clip-rule:evenodd}.st1{fill-rule:evenodd;fill:url(#SVGID_10_)}.st2{fill-rule:evenodd;fill:#942270}.st2,.st3{clip-rule:evenodd}.st3{fill-rule:evenodd;fill:#fff}", ""]);
// Exports
module.exports = exports;
